<template>
    <div class="column-wrap" :style="WrapStyle">
        <div class="rows-wrap" :style="RowStyle" v-for="(list, row) in rows" :key="row">
            <div class="list" :style="ColumnStyle" v-for="(item, column) in list" :key="row + column">
                <slot :item="item" :row="row" :column="column" />
            </div>
        </div>
    </div>
</template>

<script setup>
import { computed } from 'vue'

const props = defineProps({
    data: {
        type: [Array],
        default: () => [],
    },
    column: {
        type: [String, Number],
        default: 1,
    },
    gap: {
        type: [String, Number],
        default: '',
    },
})

const rows = computed(() => {
    const list = []
    const myData = [...props.data]
    const length = Math.ceil(props.data.length / props.column)
    for (let i = 0; i < length; i++) {
        list.push(myData.splice(0, props.column))
    }
    return list
})

const WrapStyle = computed(() => {
    return {
        gap: props.gap,
    }
})

const RowStyle = computed(() => {
    return {
        gap: props.gap,
    }
})

const ColumnStyle = computed(() => {
    return {
        width: `calc((100% - ${props.gap} * ${props.column - 1}) / ${props.column})`,
    }
})
</script>

<style lang="scss" scoped>
.column-wrap {
    display: flex;
    flex-flow: column;
    .rows-wrap {
        display: flex;
    }
    .list {
        display: flex;
        flex-flow: column;
        position: relative;
    }
}
</style>
